// generated by scripts/make_cursors.mjs, do not edit by hand. every pack has `<id>.svg` and `<id>-ptr.svg` in
// app/renderer/assets/cursors, 32x32. hot is the click point in both files, mature packs are suggestive only
import type { Choice } from "./look_prefs";

export interface CursorPack extends Choice {
  group: string;
  hot: [number, number];
}

export const CURSOR_PACKS: CursorPack[] = [
  { id: "pixel-arrow", label: "pixel arrow", group: "classic", hot: [3, 2] },
  { id: "crosshair", label: "crosshair", group: "classic", hot: [16, 16] },
  { id: "chi-ring", label: "chi cyan ring", group: "classic", hot: [16, 16] },
  { id: "gamepad-dot", label: "d-pad", group: "classic", hot: [16, 16] },
  { id: "diamond", label: "diamond", group: "classic", hot: [16, 16] },
  { id: "key", label: "key", group: "classic", hot: [9, 9] },
  { id: "sword", label: "sword", group: "classic", hot: [5, 5] },
  { id: "magic-wand", label: "magic wand", group: "classic", hot: [8, 8] },
  { id: "star-wand", label: "star wand", group: "classic", hot: [9, 9] },
  { id: "floppy", label: "floppy disk", group: "classic", hot: [16, 16] },
  { id: "cassette", label: "cassette", group: "classic", hot: [16, 16] },
  { id: "hourglass", label: "hourglass", group: "classic", hot: [16, 16] },
  { id: "heart", label: "heart", group: "cute", hot: [16, 16] },
  { id: "cat-paw", label: "cat paw", group: "cute", hot: [16, 16] },
  { id: "bunny-ears", label: "bunny ears", group: "cute", hot: [16, 19] },
  { id: "ghost", label: "ghost", group: "cute", hot: [16, 16] },
  { id: "ribbon", label: "ribbon bow", group: "cute", hot: [16, 16] },
  { id: "bubble", label: "bubble", group: "cute", hot: [16, 16] },
  { id: "strawberry", label: "strawberry", group: "cute", hot: [16, 16] },
  { id: "cherry", label: "cherry", group: "cute", hot: [16, 16] },
  { id: "clover", label: "clover", group: "cute", hot: [16, 16] },
  { id: "mushroom", label: "mushroom", group: "cute", hot: [16, 16] },
  { id: "orb", label: "crystal orb", group: "magic", hot: [16, 16] },
  { id: "moon", label: "moon", group: "magic", hot: [16, 16] },
  { id: "sun", label: "sun", group: "magic", hot: [16, 16] },
  { id: "lightning", label: "lightning", group: "magic", hot: [16, 16] },
  { id: "eye", label: "eye", group: "magic", hot: [16, 16] },
  { id: "snowflake", label: "snowflake", group: "magic", hot: [16, 16] },
  { id: "sakura", label: "sakura petal", group: "magic", hot: [16, 16] },
  { id: "comet", label: "comet", group: "magic", hot: [9, 9] },
  { id: "planet", label: "planet", group: "space", hot: [16, 16] },
  { id: "rocket", label: "rocket", group: "space", hot: [6, 6] },
  { id: "star", label: "star", group: "space", hot: [16, 16] },
  { id: "flame", label: "flame", group: "nature", hot: [16, 16] },
  { id: "leaf", label: "leaf", group: "nature", hot: [16, 16] },
  { id: "skull", label: "skull", group: "spooky", hot: [16, 16] },
  { id: "bat", label: "bat", group: "spooky", hot: [16, 16] },
  { id: "lips", label: "lips", group: "after dark", mature: true, hot: [16, 16] },
  { id: "kiss-mark", label: "kiss mark", group: "after dark", mature: true, hot: [16, 20] },
  { id: "peach", label: "peach", group: "after dark", mature: true, hot: [16, 16] },
  { id: "cherry-pair", label: "cherry pair", group: "after dark", mature: true, hot: [16, 16] },
  { id: "handcuffs", label: "handcuffs", group: "after dark", mature: true, hot: [16, 16] },
  { id: "heart-keyhole", label: "heart keyhole", group: "after dark", mature: true, hot: [16, 16] },
  { id: "devil-horns", label: "devil horns", group: "after dark", mature: true, hot: [16, 18] },
  { id: "stiletto", label: "stiletto", group: "after dark", mature: true, hot: [16, 16] },
  { id: "red-rose", label: "red rose", group: "after dark", mature: true, hot: [16, 11] },
  { id: "fangs", label: "fangs and bite", group: "after dark", mature: true, hot: [16, 14] },
  { id: "lollipop", label: "lollipop", group: "after dark", mature: true, hot: [16, 11] },
  { id: "collar-tag", label: "collar and tag", group: "after dark", mature: true, hot: [16, 14] },
  { id: "red-light", label: "red light", group: "after dark", mature: true, hot: [16, 14] }
];
